module.exports = __webpack_public_path__ + "img/base.de203511.png";